import { getAuthToken } from '../providers/authTokenProvider';

const hasAuthToken = () => !!getAuthToken();

export { hasAuthToken };
